import {ElasticParserType, ElasticValidatorType} from "asax-elastic";

export const numericalOperatorsTooltip = 'Available operators: "<" (less than), ">" (greater than), ".." (range), "|" (or)';
export const regexOperatorsTooltip = 'Available operators: "*" (any text), "?" (any single character), "|" (or)';

export type SearchInputType =
  'source-resolver'
  | 'switch'
  | 'dropdown'
  | 'typeahead'
  | 'science-keywords'
  | 'sky-objects'
  | 'target-list'
  | 'text';

export interface DropdownItem {
  readonly value: string;
  readonly text: string;
  readonly info?: string;
  selected?: boolean;
}

export interface SearchInput {
  readonly id: string;
  readonly legacyId?: string;

  readonly label: string;
  readonly type: SearchInputType;
  readonly info?: string;
  readonly description?: string;
  readonly units?: string;
  readonly examples?: string[];
  readonly isDisabled?: boolean;

  readonly elasticParserType: ElasticParserType;
  readonly elasticValidatorType?: ElasticValidatorType;

  readonly tooltip?: string;

  value?: string;
}

export interface TextSearchInput extends SearchInput {
}

export interface DropdownSearchInput extends SearchInput {
  readonly dropdownItems: DropdownItem[];
}

export interface TypeaheadSearchInput extends SearchInput {
  readonly typeaheadKeyword?: string;
  readonly typeaheadIndex?: string;
}

export interface SearchInputGroup {
  readonly id: string;
  readonly title: string;
  readonly icon: string;
  readonly searchInputs?: (TextSearchInput | DropdownSearchInput | TypeaheadSearchInput)[];
}
